










































































import { Component, Prop, Vue } from "vue-property-decorator";
import Scoring from "@/store/modules/Scoring";
import { getModule } from "vuex-module-decorators";
import Viewpoints, { ChoiceFactorScoreChange } from "@/store/modules/Viewpoints";
import Users from "@/store/modules/Users";
import ScoreSliderKey from "@/components/scoring-input/ScoreSliderKey.vue";
import ScoringKeys from "@/store/modules/ScoringKeys";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import CommentBadge from "@/components/comments/CommentBadge.vue";
import { ResourceType } from "@/store/modules/Comments";
import Choices from "@/store/modules/Choices";
import Decisions from "@/store/modules/Decisions";
import Modelling from "@/store/modules/Modelling";
import { Factor } from "@/api/model/FactorResource";
import { Viewpoint } from "@/api/model/Viewpoint";
import Weighting from "@/store/modules/Weighting";

const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const usersModule = getModule(Users);
const scoringModule = getModule(Scoring);
const scoringKeyModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);
const weightingModule = getModule(Weighting);
@Component({components: {CommentBadge, ScoringSliderSelect: ScoreSliderKey}})
export default class ViewpointFactorScore extends Vue {

    @Prop()
    decisionId: string;

    @Prop()
    viewpoint!: Viewpoint;

    @Prop()
    factorResourceId!: string;

    @Prop()
    choiceId!: string;

    @Prop({default: true, type: [Boolean, String]})
    thumbLabel!: boolean | string;

    @Prop({default: true, type: Boolean})
    displayScoringKey!: boolean;

    @Prop({default: true, type: Boolean})
    showComments!: boolean;

    @Prop({default: false, type: Boolean})
    displayPercentValue!: boolean;

    @Prop({default: 150, type: Number})
    columnWidth!: number;

    private submitting = false;

    get scoresVisibility() {
        return workspaceOptionsModule.scoresVisibility;
    }

    get scoreWidth(){
        return this.columnWidth- 64;
    }
    get sliderWidth(){
        return this.columnWidth -44;
    }

    get scoringSuffix() {
        if(workspaceOptionsModule.customRangeActive)
            return decisionsModule.scoringSuffix
        else
            return '%';
    }

    get scoringRangeMax() {
        if(workspaceOptionsModule.customRangeActive)
            return decisionsModule.scoringRangeMax
        else
            return 100;
    }


    get commentsVisibility() {
        return workspaceOptionsModule.commentsVisibility;
    }

    get springID(): string {
        return 'c26a7bed-a663-44aa-b41d-3343a040889c';
    }

    get isViewpointOwner() {
        return usersModule.currentUserProfile && this.viewpoint.ownerUserId === usersModule.currentUserProfile.userId;
    }

    get decisionAdminUsers(): any[] {
        if (decisionsModule.selectedDecisionUsers) {
            return Object.values(decisionsModule.selectedDecisionUsers)
                .filter(u => u.permissionAccess === 'OWNER' || u.permissionAccess === 'ADMIN')
                .map(u => u.userId)
        }
        return [];
    }

    get isDecisionAdmin() : boolean {
        return decisionsModule.isAdminOrOwner;
    }

    get factorResource() {
        return modellingModule.publishedModelFactorResources[this.factorResourceId];
    }

    get resource() {
        if (this.viewpoint) {
            return {
                name: this.viewpoint.name,
                id: this.viewpoint.viewpointId,
                type: ResourceType.VIEWPOINT
            }
        }
    }

    get secondaryResource() {
        if (getModule(Choices).choices[this.choiceId]) {
            return {
                id: this.choiceId,
                type: ResourceType.CHOICE,
                name: getModule(Choices).choices[this.choiceId].name
            }
        }
    }

    get tertiaryResource() {
        if (this.factorResource) {
            return {
                id: this.factorResourceId,
                type: ResourceType.FACTOR,
                name: this.factorResource.name
            }
        }
    }

    get invalidatedStatus() {
        return scoringModule.invalidatedViewpointScoring[this.viewpoint.viewpointId];
    }

    get displayScoreBar() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    get displayScoringKeysWorkspaceOption() {
        return workspaceOptionsModule.scoringKeyVisibility;
    }

    get name() {
        if (this.factorResource) return this.factorResource.name;
    }

    get viewpointFactor() {
        if (viewpointsModule.viewpointFactorResources[this.viewpoint.viewpointId]
            && viewpointsModule.viewpointFactorResources[this.viewpoint.viewpointId][this.factorResourceId]) {
            return viewpointsModule.viewpointFactorResources[this.viewpoint.viewpointId][this.factorResourceId];
        }
    }

    get viewpointChoiceFactorResource() {
        if (viewpointsModule.viewpointChoiceFactorResource[this.viewpoint.viewpointId]
            && viewpointsModule.viewpointChoiceFactorResource[this.viewpoint.viewpointId][this.choiceId]) {
                console.log("DEBUG", viewpointsModule.viewpointFactorResources)
            return viewpointsModule.viewpointChoiceFactorResource[this.viewpoint.viewpointId][this.choiceId][this.factorResourceId];
        }
        return null;
    }

    get factorScore() {
        if (scoringModule.viewpointScores[this.viewpoint.viewpointId] && scoringModule.viewpointScores[this.viewpoint.viewpointId].choiceScores[this.choiceId]) {
            return scoringModule.viewpointScores[this.viewpoint.viewpointId].choiceScores[this.choiceId].choiceFactorScores[this.factorResourceId];
        }
    }

    get score() {
        if (this.factorScore) {
            return this.factorScore.score;
        } else if (this.viewpointChoiceFactorResource && this.viewpointChoiceFactorResource.score != null) {
            return this.viewpointChoiceFactorResource.score;
        } 
        return 0;
    }

    get weight() {
        if(this.viewpoint != null &&  weightingModule.viewpointGroupDots[this.viewpoint.viewpointId])
            return weightingModule.viewpointGroupDots[this.viewpoint.viewpointId][this.factorResourceId]
        
        else 
            return 1;
    }

    get standardization() {
        if(this.standardizeDenominator) {
            return this.scoringRangeMax / this.weight;
        }
        else {
            return 1;
        }
    }

    get hasWeight() {
       if(this.viewpoint != null &&  weightingModule.viewpointGroupDots[this.viewpoint.viewpointId])
            return weightingModule.viewpointGroupDots[this.viewpoint.viewpointId][this.factorResourceId] > 0
        else
            return 1;
    
    }

    get totalVpWeight() {
        if(this.viewpoint != null &&  weightingModule.viewpointGroupDots[this.viewpoint.viewpointId])
            return weightingModule.viewpointGroupDots[this.viewpoint.viewpointId]['M']
        else {
            return 1;
        } 
       
    }

    get isManualScore() {
        if ( workspaceOptionsModule.editScores ) {
            return (this.isDecisionAdmin || this.isViewpointOwner) && (this.factorResource.type !== 'FACTOR_GROUP'
                && (!this.factorResource
                    || !(this.factorResource as Factor).scoringDefinition
                    || (this.factorResource as Factor).scoringDefinition.type === 'MANUAL')
                && (!this.viewpointFactor
                    || !this.viewpointFactor.scoringDefinition
                    || this.viewpointFactor.scoringDefinition.type === 'MANUAL'));
        } else {
            return false;
        }
    }

    get viewpointScoringKeys() {
        return scoringKeyModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId];
    }

    get scoringKey() {
        if (!this.displayScoringKey || this.factorResource == null || !this.displayScoringKeysWorkspaceOption) return null;
        let scoringKeys
        if (this.viewpointScoringKeys) {
            scoringKeys = this.viewpointScoringKeys[this.factorResourceId];
        } else {
            return null;
        }
        if (scoringKeys) {
            return scoringKeys.scoringKeys;
        }
    }
    // get style based on the bar visibility
    get commentStyle(){
        if (this.displayScoreBar){
            return 'margin-top:16px';
        }
        else{
            return 'margin-top:4px';
        }
    }

    get autoCalc() {
        return workspaceOptionsModule.autoCalc;
    }

    get denominatorScoring() {
        return workspaceOptionsModule.denominatorScoring
    }

    get standardizeDenominator() {
        return workspaceOptionsModule.standardizeDenominator
    }

    private showViewpointFactorScore( factorHideScore: boolean) {
        if (this.viewpointFactor) {
            if (this.viewpointFactor.hasOwnProperty('hideScores')) {
                return !this.viewpointFactor.hideScores;
            }
        }
        else if ( factorHideScore != undefined ) {
            return !factorHideScore;
        }
        return true;
    }

    private async submitUserScore(userScore: number) {
        if (userScore === this.score) return;
        let payload: ChoiceFactorScoreChange = {
            viewpointId: this.viewpoint.viewpointId,
            choiceId: this.choiceId,
            factorId: this.factorResourceId,
            score: userScore
        };
        if(this.autoCalc){
            this.submitting = true;
        }
        try {
            await viewpointsModule.putViewpointChoiceFactorScore(payload);
        } catch (e) {

        }
        this.submitting = false;
    }

    private getColor(value: number | null | undefined): string {
        if (this.decisionId === this.springID && value !== null && value !== undefined) {
            switch (true) {
                case (value * 5 == 5):
                    return '2e9e49';
                case (value * 5 >= 4.5):
                    return '53a94d';
                case (value * 5 >= 4):
                    return '7bb251';
                case (value * 5 >= 3.5):
                    return 'a5bc55';
                case (value * 5 >= 3):
                    return 'd2c658';
                case (value * 5 >= 2.5):
                    return 'ffd05b';
                case (value * 5 >= 2):
                    return 'f5af60';
                case (value * 5 >= 1.5):
                    return 'ec8f64';
                case (value * 5 >= 1):
                    return 'e27068';
                case (value * 5 >= 0.5):
                    return 'e27068';
                default:
                    return 'e27068';
            }
        }
        return '';
    }


}
